const empresa_prazo_calendario = {
	name: "empresa-prazo-calendario",
	path: "/empresas/:empresaPk/prazos",
	component: () =>
		import("@/views/prazo/calendario/Calendario.vue"),
	meta: {
		rule: ["autenticadosuperuser", "prazovisualizar"]
	}
};

const empresa_prazo_listar = {
	name: "empresa-prazo-listar",
	path: "/empresas/:empresaPk/prazos/listar",
	component: () =>
		import("@/views/prazo/prazo_listar/Prazos.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser", "prazovisualizar"]
	}
};


export default [
	empresa_prazo_calendario,
	empresa_prazo_listar
];
